<template>
    <el-container>
  
      <el-row :gutter="10">
        <el-col :span="24">
            <el-row :gutter="10">
              <el-col :span="16">
      
                <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
                  <el-form-item>
                    <el-button type="primary" icon="el-icon-edit" @click="newPatrolRoad(0)">新增</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="selectedHoldName" placeholder="请选择" style="width:166px;"></el-input>
                    <el-button type="default" icon="el-icon-folder-opened" @click="openLayer">打开组织树</el-button>
                    <div v-if="isVisible" class="floating-layer">
                      <div class="layer-content">
                        <!-- 浮动层内容 -->
                        <div class="tree-divBox">
                          <el-tree 
                            :data="holdTreeData" 
                            :props="defaultProps" 
                            default-expand-all 
                            ref="getTreeInstance" 
                            @node-click="handleNodeClick"></el-tree>
                        </div>
                        <el-button type="info" size="mini" icon="el-icon-close" @click="closeLayer" circle></el-button>
                      </div>
                      <!-- <div class="overlay" @click="closeLayer"></div> -->
                    </div>
                  </el-form-item>
                  <el-form-item label="状态">
                    <el-select v-model="formInline.status" placeholder="筛选状态" style="width:120px;">
                      <el-option
                        v-for="item in status_options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="线路名称">
                    <el-input v-model="formInline.key" placeholder="关键词"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="success" icon="el-icon-search" @click="LoadRoadList()">查询</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
              <el-col :span="8">
                <el-form :inline="true" class="demo-form-inline" size="mini" style="text-align: right;">
                  <el-form-item>
                    <el-button round @click="LoadRoadList()">查看巡检计划</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="16">
  
              </el-col>
            </el-row>
            
            <div>
                <el-table
                  id="tbGridView"
                  ref="getTableInstance"
                  :data="tableData"
                  :height="tableViewHeight"
                  v-loading="loadingTableData"
                  size="small"
                  stripe
                  style="width: 100%">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    label="状态"
                    width="80">
                  </el-table-column>
                  <el-table-column
                    prop="road_name"
                    label="巡检路线名称"
                    width="200">
                    <template slot-scope="scope">
                      <div>{{ scope.row.road_name }}</div>
                      <el-button type="text" size="small" @click="openPatrolCardForm(scope.row.road_id)">编辑</el-button>
                      <el-button type="text" size="small" @click="removePatrolCard(scope.row.road_id)">关闭</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="patrol_users"
                    label="巡检账号"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="cycle"
                    label="周期"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="start_time"
                    label="开始时间"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="end_time"
                    label="结束时间"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="patrol_cards"
                    label="巡检项"
                    width="300">
                  </el-table-column>
                  <el-table-column
                    prop="remark"
                    label="备注">
                  </el-table-column>
                  <el-table-column
                    prop="create_time"
                    label="录入时间"
                    width="200">
                  </el-table-column>
                </el-table>
            </div>
  
            <div class="dv-pagging-container">
              <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pagging.pager_size"
                :pager-count="pagging.pager_count"
                :total="pagging.records_total">
              </el-pagination>
            </div>
        </el-col>
      </el-row>
  
      <NewPatrolRoadForm ref="newPatrolRoadForm" @eventRefreshTableName="LoadRoadList" />
  
    </el-container>
  </template>
  
  <script>
  import Api from '../../api/index'
  import NewPatrolRoadForm from './NewPatrolRoadFormView.vue'
  
  export default {
    name: 'patrolroad_state',
    components: {
      NewPatrolRoadForm
    },
    data() {
      return {
        isVisible: false, // 控制浮动层是否显示
        dialogFormVisible: false,
        currentTabsNodeName: "staff-department",
        formInline: {
          key: '',
          search_type: 'device_no',
          status: '',
        },
        status_options: [
          { label: "全部", value: -1 },
          { label: "未开始", value: 0 },
          { label: "进行中", value: 1 },
          { label: "已结束", value: 2 },
          { label: "异常", value: 3 },
          { label: "已关闭", value: 4 }
        ],
        formInline2: {
          radio_status: 1,
        },
        tableViewHeight: 600,
        loadingTableData: false,
        selectHoldId: 0,
        selectedHoldName: "",
        holdTreeData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        tableData: [],
        pagging: {
          records_total: 0,
          pager_count: 5,
          pager_size: 25,
          current_page: 1
        },
        popover_text: "巡检账号列表展示。",
        popover_card_text: "巡检项列表展示",
      }
    },
    methods: {
      loadHoldTree: function(){
        Api.GetHoldTree({}).then(res => {
          if(!res)
            return;
          this.holdTreeData = res.data;
  
          // 初始化选中的用户id
          this.selectHoldId = this.holdTreeData[0].id;
        });
      },
      LoadRoadList: function() {
        this.loadingTableData = true;
        var argdata = {
          road_name: this.formInline.key,
          hold_id: this.selectHoldId,
          PageIndex: this.pagging.current_page,
          PageSize: this.pagging.pager_size
        };
        if(this.formInline.status) {
          argdata.status = this.formInline.status;
        }
        
        this.tableData = [];
        Api.GetPatrolRoadList(argdata).then(res => {
          this.loadingTableData = false;
          if(!res)
            return;
          if(res.code != 200) {
            this.$message.error(err);
          }
          if(res.data) {
            this.pagging.records_total = res.total;
            for(var i=0; i<res.data.length; i++) {
              var repeatItems = "";
              if(res.data[i].cycle_everydays === 1) {
                repeatItems = "每天重复";
              } else if (res.data[i].cycle_weeks) {
                repeatItems = res.data[i].cycle_weeks;
              } else if (res.data[i].cycle_monthdays) {
                repeatItems = res.data[i].cycle_monthdays;
              }
              this.tableData.push({
                number: (i + 1),
                road_id: res.data[i].road_id,
                status: res.data[i].status,
                road_name: res.data[i].road_name,
                patrol_users: res.data[i].patrol_users,
                cycle: repeatItems,
                start_time: this.convertHHmm(res.data[i].start_time),
                end_time: this.convertHHmm(res.data[i].end_time),
                patrol_cards: res.data[i].patrol_cards,
                remark: res.data[i].remark,
                create_time: res.data[i].create_time,
              });
            }
          }
        }).catch(err => {
          this.$message.error('错了哦，接口出错！' + err);
          this.loadingTableData = false;
        });
      },
      handleNodeClick: function(data) {
        this.selectHoldId = data.id;
  
        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
  
        this.LoadRoadList();
      },
      newPatrolRoad: function(id) {
        const routeUrl = this.$router.resolve({ path: 'road_detail', query: {id : id, holdid : this.selectHoldId} });
        console.log(routeUrl.href);
        window.open(routeUrl.href, '_blank');
      },
      convertHHmm: function(data) {
        if(data && data.indexOf(':') > 1) {
          const b = data.split(':');
          return `${b[0]}:${b[1]}`;
        }
        return data;
      },
      openPatrolCardForm: function(id) {
        const routeUrl = this.$router.resolve({ path: 'road_detail', query: {id : id, holdid : this.selectHoldId} });
        window.open(routeUrl.href, '_blank');
      },
      removeDevice: function(id) {
        this.$confirm('此操作将删除该设备信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
           var argdata = {
              object_ids: [id]
            };
            Api.RemoveDevice(argdata).then(res => {
              if(res.code === 200) {
                    this.$message({
                        message: '已删除！',
                        type: 'success'
                    });
                    this.LoadRoadList();
                } else {
                    this.$message({
                        message: '删除失败！',
                        type: 'warning'
                    });
                }
            });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      showAccountPopovers: function(id) {
        this.popover_text = "账号加载中..." + id;
        Api.GetBindAccounts({ road_id: id }).then(res => {
          if(res.code === 200) {
            var text = "";
            for(var i=0; i<res.data.length; i++) {
              if(res.data[i].true_name) {
                text += res.data[i].true_name + "/" + res.data[i].user_name;
              } else {
                text += res.data[i].user_name;
              }
              text += ", ";
            }
            this.popover_text = text;
          }
        });
      },
      showCardPopovers: function(id) {
        this.popover_card_text = "巡检项加载中..." + id;
        Api.GetBindCards({ road_id: id }).then(res => {
          if(res.code === 200) {
            var text = "";
            for(var i=0; i<res.data.length; i++) {
              text += res.data[i].patrol_name;
              text += ", ";
            }
            this.popover_card_text = text;
          }
        });
      }
    },
    mounted() {
      var h = document.body.clientHeight - 50 - 205;
      var h2 = document.body.clientHeight - 165;
      this.$nextTick(() => {
        const table = this.$refs.getTableInstance;
        if (table) {
          // 使用原生JavaScript设置高度
          table.$el.style.height = h + 'px';
          // 或者使用Vue.set来响应式地更新样式
          // this.$set(table.$el.style, 'height', '300px');
        }
        const tree = this.$refs.getTreeInstance;
        if(tree) {
          tree.$el.style.height = h2 + 'px';
        }
      });
  
      this.loadHoldTree();
      this.LoadRoadList();
  
    }
  }
  </script>
  <style>
  .tree-divBox {
    padding-top: 10px;
    padding-left: 10px;
    width: 95%;
    min-height: 500px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  }
  </style>